import { Component } from '@angular/core';
import { AmorphicService } from '../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { Controller } from '../../Controller';

@Component({
  moduleId: module.id,
  selector: 'sign-complete',
  templateUrl: './sign-complete.component.html',
})
export class SignCompleteComponent {
  controller: Controller;

  constructor(private amorphicService: AmorphicService) {
    this.controller = amorphicService.controller as Controller;
  }
}
